import { ExIcon, IconSize } from '@boomi/exosphere';
import { useApp } from '../common/AppProvider';
import { translations } from '../translations/translations';
import Loading from '../Loading';

import './auth-status-badge.css';

const AuthStatusBadge = ({
    connectorId,
    isConnectorAuthenticated,
    isLoadingAuthenticationStatus,
}: {
    connectorId: string;
    isConnectorAuthenticated: boolean;
    isLoadingAuthenticationStatus: boolean;
}) => {
    const { language } = useApp();

    return isLoadingAuthenticationStatus ? (
        <div
            key="loading-badge"
            className="loading-badge"
            data-testid={`${connectorId}_authStatusLoading`}
        >
            <Loading message={translations[language].COMMON_loading} />
        </div>
    ) : (
        <div
            className={`status-badge ${isConnectorAuthenticated ? 'authenticated' : 'not-authenticated'}`}
            title={
                isConnectorAuthenticated
                    ? translations[language].TASK_authenticated
                    : translations[language].TASK_not_authenticated
            }
        >
            <ExIcon
                className="badge-icon"
                icon={isConnectorAuthenticated ? 'Authenticated' : 'Error'}
                hide-browser-tooltip
                size={IconSize.S}
            />
            <span className="badge-text">
                {isConnectorAuthenticated
                    ? translations[language].TASK_authenticated
                    : translations[language].TASK_not_authenticated}
            </span>
        </div>
    );
};

export default AuthStatusBadge;
